import { render, staticRenderFns } from "./publicItem.vue?vue&type=template&id=61a7b8aa"
import script from "./publicItem.vue?vue&type=script&lang=js"
export * from "./publicItem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports